import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class PartnerHttpClientService {
  BASE_URL: string = environment.partnerApiBaseUrl;
  constructor(private http: HttpClient) { }

  get<T>(url: string, data: any = {}) {
    url = this.BASE_URL + url;
    return this.http.get<T>(url, {withCredentials: true});
  }
  put<T>(url: string, data: any = {}) {
    url = this.BASE_URL + url;
    return this.http.put<T>(url, data, {withCredentials: true});
  }
  remove<T>(url: string) {
    url = this.BASE_URL + url;
    return this.http.delete<T>(url, {withCredentials: true});
  }
  post<T>(url: string, data: any, header = {}) {
    url = this.BASE_URL + url;
    return this.http.post<T>(url, data, {withCredentials: true});
  }

}
